/* A selected photo stays local until its upload is confirmed. Only then add a real cart line. */
(function (root) {
  'use strict';
  if (root.BAFPendingPortrait) return;
  var MARKER = 'baf_pending_portrait';
  var jobs = new Map(), liveUploads = new Map(), running = new Map(), listeners = new Set(), progressByJob = new Map();
  var owner = Date.now() + '-' + Math.random().toString(36).slice(2);
  var dbPromise, initialization, utilsPromise;
  var active = function (job) { return job.status !== 'complete' && job.status !== 'cancelled'; };
  function error(message, code) { var err = new Error(message); err.code = code; return err; }
  function markerPresent() { try { return root.localStorage.getItem(MARKER) === '1'; } catch (_) { return false; } }
  function setMarker() {
    var pending = Array.from(jobs.values()).some(active);
    if (pending) {
      root.localStorage.setItem(MARKER, '1');
      if (!markerPresent()) throw error('Your browser could not save the photo. Please keep this page open and try again.', 'portrait-storage');
    } else root.localStorage.removeItem(MARKER);
  }
  function summary(job) {
    return { id: job.id, status: job.status, message: job.message || '', progress: job.progress || 0,
      display: job.display || {}, canCancel: !job.commitStarted && job.status !== 'adding' && active(job), error: job.error || '' };
  }
  function list() { return Array.from(jobs.values()).filter(active).map(summary); }
  function emit() {
    var value = list();
    listeners.forEach(function (fn) { try { fn(value); } catch (_) {} });
    root.document.dispatchEvent(new root.CustomEvent('baf:pending-portrait-change', { detail: { jobs: value } }));
  }
  function openDb() {
    if (dbPromise) return dbPromise;
    dbPromise = new Promise(function (resolve, reject) {
      if (!root.indexedDB) { reject(error('This browser cannot save a pending photo. Please keep this page open until the upload finishes.', 'portrait-storage')); return; }
      var settled = false, request;
      var timer = root.setTimeout(function () { finish(error('Saving your photo took too long. Please try again.', 'portrait-storage')); }, 8000);
      function finish(err, db) { if (settled) { if (db) db.close(); return; } settled = true; root.clearTimeout(timer); if (err) reject(err); else resolve(db); }
      try { request = root.indexedDB.open('baf-pending-portraits', 1); }
      catch (err) { finish(err); return; }
      request.onupgradeneeded = function () { request.result.createObjectStore('jobs', { keyPath: 'id' }); };
      request.onsuccess = function () { finish(null, request.result); };
      request.onerror = function () { finish(request.error || error('Your photo could not be saved on this device.', 'portrait-storage')); };
      request.onblocked = function () { finish(error('Please close the other store tab and retry saving your photo.', 'portrait-storage')); };
    });
    return dbPromise;
  }
  function transaction(mode, operation) {
    return openDb().then(function (db) {
      return new Promise(function (resolve, reject) {
        var tx = db.transaction('jobs', mode), result;
        var timer = root.setTimeout(function () { try { tx.abort(); } catch (_) {} reject(error('Saving your photo took too long. Please try again.', 'portrait-storage')); }, 8000);
        tx.oncomplete = function () { root.clearTimeout(timer); resolve(result); };
        tx.onerror = tx.onabort = function () { root.clearTimeout(timer); reject(tx.error || error('Your photo could not be saved on this device.', 'portrait-storage')); };
        operation(tx.objectStore('jobs'), function (value) { result = value; });
      });
    });
  }
  function save(job) {
    return transaction('readwrite', function (store, done) {
      var request = store.get(job.id);
      request.onsuccess = function () {
        var saved = request.result;
        if (saved && ((!active(saved) && active(job)) || (saved.owner && saved.owner !== owner))) { done(saved); return; }
        store.put(job);
      };
    }).then(function (blocked) {
      if (blocked) {
        Object.assign(job, blocked);
        throw error('This portrait is being handled in another tab.', 'portrait-lease-lost');
      }
    });
  }
  function readAll() { return transaction('readonly', function (store, done) { var request = store.getAll(); request.onsuccess = function () { done(request.result || []); }; }); }
  function syncStoredMarker() {
    return readAll().then(function (stored) {
      if (stored.some(active)) root.localStorage.setItem(MARKER, '1');
      else root.localStorage.removeItem(MARKER);
    });
  }
  function claim(id, ownsBrowserLock) {
    return transaction('readwrite', function (store, done) {
      var request = store.get(id);
      request.onsuccess = function () {
        var job = request.result;
        if (!job || !active(job) || (!ownsBrowserLock && job.owner && job.owner !== owner && job.leaseUntil > Date.now())) { done({ unavailable: true, saved: job }); return; }
        job.owner = owner; job.leaseUntil = Date.now() + 30000; store.put(job); done(job);
      };
    });
  }
  function renew(id) {
    return transaction('readwrite', function (store) {
      var request = store.get(id);
      request.onsuccess = function () { var job = request.result; if (job && active(job) && job.owner === owner) { job.leaseUntil = Date.now() + 30000; store.put(job); } };
    });
  }
  function commitReady(job) {
    return transaction('readwrite', function (store, done) {
      var request = store.get(job.id);
      request.onsuccess = function () {
        var saved = request.result;
        if (!saved || !active(saved) || saved.owner !== owner) { done(false); return; }
        job.commitStarted = true; store.put(job); done(true);
      };
    });
  }
  function reportProgress(id, fileId, percent) {
    var job = jobs.get(id);
    if (!job || !active(job) || job.status === 'adding' || job.status === 'failed') return;
    var values = progressByJob.get(id) || new Map(); progressByJob.set(id, values);
    values.set(fileId, Math.max(0, Math.min(100, Number(percent) || 0)));
    var total = job.files.reduce(function (sum, photo) { return sum + (photo.url ? 100 : values.get(photo.id) || 0); }, 0);
    var progress = Math.round(total / Math.max(job.files.length, 1));
    setStatus(job, 'uploading', progress >= 100 ? 'Finishing your photo upload…' : 'Uploading your photo… ' + progress + '%', progress);
  }
  function loadUtils(config) {
    if (root.BafPhotoUploadUtils) return Promise.resolve(root.BafPhotoUploadUtils);
    if (utilsPromise) return utilsPromise;
    utilsPromise = new Promise(function (resolve, reject) {
      if (!config.assetUrl) { reject(error('Photo preparation is unavailable. Please retry.', 'portrait-upload')); return; }
      var script = root.document.createElement('script'), settled = false;
      var timer = root.setTimeout(function () { finish(error('Photo preparation took too long to load. Please retry.', 'portrait-upload')); }, 15000);
      function finish(err) { if (settled) return; settled = true; root.clearTimeout(timer); script.onload = script.onerror = null; if (err) { script.remove(); reject(err); } else resolve(root.BafPhotoUploadUtils); }
      script.src = config.assetUrl; script.async = true;
      script.onload = function () { finish(root.BafPhotoUploadUtils ? null : error('Photo preparation is unavailable.', 'portrait-upload')); };
      script.onerror = function () { finish(error('Photo preparation could not load. Please retry.', 'portrait-upload')); };
      root.document.head.appendChild(script);
    }).catch(function (err) { utilsPromise = null; throw err; });
    return utilsPromise;
  }
  function upload(blob, fileName, config, task, onProgress) {
    function attempt(retries) {
      return new Promise(function (resolve, reject) {
        if (task.cancelled) { reject(error('Photo upload cancelled.', 'portrait-cancelled')); return; }
        var xhr = new root.XMLHttpRequest(), settled = false;
        function finish(err, value) { if (settled) return; settled = true; task.cancel = null; xhr.onload = xhr.onerror = xhr.ontimeout = xhr.onabort = null; if (xhr.upload) xhr.upload.onprogress = null; if (err) reject(err); else resolve(value); }
        task.cancel = function () { finish(error('Photo upload cancelled.', 'portrait-cancelled')); xhr.abort(); };
        xhr.open('POST', 'https://api.cloudinary.com/v1_1/' + config.cloudName + '/image/upload', true);
        xhr.timeout = 120000;
        if (xhr.upload) xhr.upload.onprogress = function (event) { if (event.lengthComputable) onProgress(Math.round(event.loaded / event.total * 100)); };
        xhr.onload = function () {
          var data; try { data = JSON.parse(xhr.responseText); } catch (_) {}
          if (xhr.status >= 200 && xhr.status < 300 && data && /^https:\/\//i.test(data.secure_url)) finish(null, data.secure_url);
          else { var err = error(data && data.error && data.error.message || 'We couldn’t upload this photo. Please retry.', 'portrait-upload'); err.retryable = xhr.status >= 500; finish(err); }
        };
        xhr.onerror = xhr.ontimeout = function () { var err = error('Your photo upload was interrupted. Please check your connection and retry.', 'portrait-upload'); err.retryable = true; finish(err); };
        xhr.onabort = function () { finish(error('Photo upload cancelled.', 'portrait-cancelled')); };
        var body = new root.FormData(); body.append('file', blob, fileName || 'portrait-photo.jpg'); body.append('upload_preset', config.uploadPreset); xhr.send(body);
      }).catch(function (err) {
        if (!retries || !err.retryable || task.cancelled) throw err;
        return new Promise(function (resolve, reject) {
          var timer = root.setTimeout(function () { task.cancel = null; resolve(); }, 1000);
          task.cancel = function () { root.clearTimeout(timer); reject(error('Photo upload cancelled.', 'portrait-cancelled')); };
        }).then(function () { return attempt(retries - 1); });
      });
    }
    return attempt(1);
  }
  function jsonRequest(url, options, timeout) {
    var controller = new root.AbortController();
    return new Promise(function (resolve, reject) {
      var timer = root.setTimeout(function () { controller.abort(); reject(error('The connection took too long. Please retry.', 'portrait-cart')); }, timeout);
      root.fetch(url, Object.assign({}, options, { signal: controller.signal })).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) { var requestError = error(data.description || data.message || 'Could not add your portrait. Please retry.', 'portrait-cart'); requestError.status = response.status; throw requestError; }
          return data;
        });
      }).then(resolve, reject).finally(function () { root.clearTimeout(timer); });
    });
  }
  function cartLine(job) {
    return jsonRequest('/cart.js', { headers: { Accept: 'application/json' } }, 8000).then(function (cart) {
      return (cart.items || []).find(function (line) { return line.properties && line.properties._baf_order_item_id === job.id; }) || null;
    });
  }
  function setStatus(job, status, message, progress) { job.status = status; job.message = message; if (progress !== undefined) job.progress = progress; emit(); }
  function announceObserved(job) {
    if (job.status === 'complete') root.document.dispatchEvent(new root.CustomEvent('baf:pending-portrait-complete', { detail: { id: job.id, lineItem: null, orderItem: job.orderItem } }));
    syncStoredMarker().catch(function () {});
    emit();
    if (job.status === 'complete') root.document.dispatchEvent(new root.CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
  }
  function postAddFollowups(job, line) {
    function bounded(operation) {
      return new Promise(function (resolve) {
        var timer = root.setTimeout(resolve, 8000);
        Promise.resolve().then(operation).catch(function () {}).finally(function () { root.clearTimeout(timer); resolve(); });
      });
    }
    if (root.BAFOrderSync && typeof root.BAFOrderSync.syncCartOrder === 'function') {
      bounded(function () { return root.BAFOrderSync.syncCartOrder({ additionalItems: [job.orderItem] }); });
    }
    if (root.BAFAddToCartAnalytics && typeof root.BAFAddToCartAnalytics.publish === 'function') {
      bounded(function () { return root.BAFAddToCartAnalytics.publish({ source: 'configurator', lineItem: line, product: {
        variant_id: String(job.variantId), quantity: 1, product: job.orderItem.product_type || job.properties.Product || '',
        product_handle: job.analytics && job.analytics.product_handle || '', product_category: job.analytics && job.analytics.product_category || '', order_item_id: job.id
      } }); });
    }
  }
  async function finish(job, line) {
    // Keep a tiny completed tombstone. An interrupted cleanup must never re-add the item.
    var completed = Object.assign({}, job, { status: 'complete', files: [], owner: null, leaseUntil: 0 });
    await save(completed);
    Object.assign(job, completed);
    liveUploads.delete(job.id); progressByJob.delete(job.id);
    try { await syncStoredMarker(); } catch (_) {}
    root.document.dispatchEvent(new root.CustomEvent('baf:pending-portrait-complete', { detail: { id: job.id, lineItem: line, orderItem: job.orderItem } }));
    emit();
    root.document.dispatchEvent(new root.CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
    postAddFollowups(job, line);
  }
  async function process(job, task) {
    try {
      // Includes recovery after a lost add response or a reload during the POST.
      var existing = await cartLine(job);
      if (existing) { await finish(job, existing); return; }
      if (task.cancelled) return;
      if (job.commitStarted && !task.explicitRetry) throw error('We could not confirm the previous cart update. Please tap Retry to check your cart and try again.', 'portrait-cart');
      var adopted = liveUploads.get(job.id) || new Map();
      for (var index = 0; index < job.files.length; index++) {
        var photo = job.files[index];
        if (photo.url) continue;
        setStatus(job, 'uploading', 'Uploading your photo…', 0);
        var live = adopted.get(photo.id);
        if (live) {
          task.cancel = live.cancel || null;
          photo.url = await live.promise;
          task.cancel = null;
          adopted.delete(photo.id);
        } else {
          var prepared = photo.preparedFile;
          if (!prepared) {
            setStatus(job, 'uploading', 'Preparing your photo…', 0);
            var utils = await loadUtils(job.utilityConfig || {});
            var controller = new root.AbortController();
            task.cancel = function () { controller.abort(); };
            prepared = await utils.prepare(photo.file, { signal: controller.signal, heicDecoderUrl: job.utilityConfig.heicDecoderUrl });
            task.cancel = null;
            photo.preparedFile = { blob: prepared.blob, fileName: prepared.fileName };
            await save(job);
          }
          if (task.cancelled) return;
          photo.url = await upload(prepared.blob, prepared.fileName, job.uploadConfig, task, function (percent) {
            reportProgress(job.id, photo.id, percent);
          });
        }
        if (task.cancelled) return;
        if (typeof photo.url !== 'string' || !/^https:\/\//i.test(photo.url)) throw error('Your photo upload was not confirmed. Please retry.', 'portrait-upload');
        // Save each confirmed URL before processing the next file or adding the item.
        await save(job);
      }
      if (task.cancelled) return;
      job.orderItem.photos = job.files.map(function (photo) { return photo.url; });
      job.properties._baf_portrait_data = JSON.stringify(job.orderItem);
      setStatus(job, 'adding', 'Adding your portrait to the cart…', 100);
      // A recovery/second tab may have completed while this page uploaded.
      existing = await cartLine(job);
      if (existing) { await finish(job, existing); return; }
      if (task.cancelled) return;
      if (!await commitReady(job)) return;
      emit();
      var line = await jsonRequest('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: job.variantId, quantity: 1, properties: job.properties }) }, 20000);
      await finish(job, line);
    } catch (err) {
      if (task.cancelled) return;
      if (err.code === 'portrait-lease-lost') { announceObserved(job); return; }
      // A definite Shopify rejection (for example sold out / 422) did not add a line.
      if (job.commitStarted && err.status >= 400 && err.status < 500) job.commitStarted = false;
      // Do not repeat a possibly successful POST. Retry first checks its stable item ID.
      if (job.commitStarted) {
        try { var recovered = await cartLine(job); if (recovered) { await finish(job, recovered); return; } } catch (_) {}
      }
      job.status = 'failed'; job.error = err.message || 'Your portrait could not be added. Please retry.'; job.message = job.error;
      job.owner = null; job.leaseUntil = 0;
      try { await save(job); } catch (_) {}
      emit();
    }
  }
  function start(id, explicitRetry) {
    if (running.has(id)) return running.get(id).promise;
    var task = { cancelled: false, cancel: null, promise: null, explicitRetry: !!explicitRetry };
    var hasBrowserLock = !!(root.navigator && root.navigator.locks);
    var work = async function () {
      var job = await claim(id, hasBrowserLock);
      if (job.unavailable) {
        if (job.saved) jobs.set(id, job.saved); else jobs.delete(id);
        if (job.saved) announceObserved(job.saved); else emit();
        // A previous page may still own the short lease while navigating away.
        if (jobs.get(id) && active(jobs.get(id))) root.setTimeout(function () { start(id); }, 31000);
        return;
      }
      jobs.set(id, job);
      var heartbeat = root.setInterval(function () { if (active(job) && !task.cancelled) renew(id).catch(function () {}); }, 10000);
      try { await process(job, task); }
      finally { root.clearInterval(heartbeat); }
    };
    task.promise = (hasBrowserLock
      ? root.navigator.locks.request('baf-pending-portrait-' + id, work) : work())
      .catch(function (err) { var job = jobs.get(id); if (job && active(job)) { job.status = 'failed'; job.message = err.message; emit(); } })
      .finally(function () { running.delete(id); });
    running.set(id, task);
    return task.promise;
  }
  function ready() {
    if (!initialization) initialization = readAll().then(function (stored) {
      stored.forEach(function (job) { jobs.set(job.id, job); });
      try { setMarker(); } catch (_) {}
      emit();
      stored.filter(function (job) { return active(job) && job.status !== 'failed'; }).forEach(function (job) { start(job.id); });
    });
    return initialization;
  }
  async function stage(snapshot, options) {
    var adopted = new Map();
    ((options && options.uploads) || []).forEach(function (item) {
      // The phone's current request can reject while IndexedDB is still opening.
      var promise = Promise.resolve(item.promise); promise.catch(function () {});
      adopted.set(item.id, { promise: promise, cancel: item.cancel });
    });
    await ready();
    if (!snapshot || !snapshot.id || !snapshot.variantId || !snapshot.orderItem || snapshot.orderItem.order_item_id !== snapshot.id || !Array.isArray(snapshot.files) || !snapshot.files.length) throw error('Your portrait could not be saved. Please try again.', 'portrait-invalid');
    if (jobs.has(snapshot.id)) return summary(jobs.get(snapshot.id));
    var job = { id: snapshot.id, variantId: snapshot.variantId,
      properties: JSON.parse(JSON.stringify(snapshot.properties || {})), orderItem: JSON.parse(JSON.stringify(snapshot.orderItem)),
      display: JSON.parse(JSON.stringify(snapshot.display || {})),
      analytics: JSON.parse(JSON.stringify(snapshot.analytics || {})),
      uploadConfig: Object.assign({}, snapshot.uploadConfig), utilityConfig: Object.assign({}, snapshot.utilityConfig),
      files: snapshot.files.map(function (photo) { return { id: photo.id, file: photo.file, preparedFile: photo.preparedFile, url: photo.url || '' }; }),
      status: 'staged', message: 'Saving your portrait…', progress: 0, createdAt: Date.now(), commitStarted: false };
    if (job.files.some(function (photo) { return !photo.id || (!photo.url && !photo.file && !photo.preparedFile); })) throw error('Your selected photo is missing. Please choose it again.', 'portrait-invalid');
    jobs.set(job.id, job);
    try { setMarker(); await save(job); }
    catch (err) { jobs.delete(job.id); try { await syncStoredMarker(); } catch (_) {} throw error('Your photo could not be saved on this device. Please keep this page open until the upload finishes.', 'portrait-storage'); }
    try { setMarker(); } catch (_) {}
    liveUploads.set(job.id, adopted); emit(); start(job.id);
    return summary(job);
  }
  async function retry(id) {
    await ready(); var job = jobs.get(id);
    if (!job || !active(job)) return;
    if (running.has(id)) return running.get(id).promise;
    liveUploads.delete(id); job.status = 'staged'; job.error = ''; job.message = 'Retrying your portrait…'; job.owner = null; job.leaseUntil = 0;
    await save(job); emit(); return start(id, true);
  }
  async function cancel(id) {
    await ready(); var job = jobs.get(id);
    if (!job || !active(job)) return;
    if (job.commitStarted || job.status === 'adding') throw error('Your portrait is being added. Please remove it from the cart once it appears.', 'portrait-committing');
    var cancelled = await transaction('readwrite', function (store, done) {
      var request = store.get(id);
      request.onsuccess = function () {
        var saved = request.result;
        if (!saved || !active(saved)) { done(saved); return; }
        if (saved.commitStarted || saved.status === 'adding') { done(null); return; }
        saved.status = 'cancelled'; saved.files = []; saved.owner = null; saved.leaseUntil = 0; store.put(saved); done(saved);
      };
    });
    if (!cancelled) throw error('Your portrait is being added. Please remove it from the cart once it appears.', 'portrait-committing');
    var callbacks = new Set();
    var task = running.get(id); if (task) { task.cancelled = true; if (task.cancel) callbacks.add(task.cancel); }
    var adopted = liveUploads.get(id); if (adopted) adopted.forEach(function (item) { if (item.cancel) callbacks.add(item.cancel); });
    callbacks.forEach(function (callback) { try { callback(); } catch (_) {} });
    Object.assign(job, cancelled); liveUploads.delete(id); progressByJob.delete(id); await syncStoredMarker(); emit();
  }
  async function assertReadyForCheckout() {
    try { await ready(); }
    catch (err) { if (markerPresent()) throw error('Your saved photo is still being prepared. Please reload this page before checkout.', 'portrait-pending'); return; }
    var stored = await readAll();
    stored.forEach(function (job) {
      if (!running.has(job.id)) {
        var previous = jobs.get(job.id);
        jobs.set(job.id, job);
        if (previous && previous.status !== job.status) announceObserved(job);
      }
    });
    var pending = list();
    if (pending.length) throw error(pending.some(function (job) { return job.status === 'failed'; })
      ? 'Your photo still needs to finish uploading. Please retry or remove the pending portrait in your cart.'
      : 'Your photo is uploading in the background. You can check out as soon as your portrait appears in the cart.', 'portrait-pending');
  }
  root.BAFPendingPortrait = { ready: ready, list: list, get: function (id) { var job = jobs.get(id); return job ? summary(job) : null; }, stage: stage, retry: retry, cancel: cancel, reportProgress: reportProgress,
    assertReadyForCheckout: assertReadyForCheckout,
    subscribe: function (fn) { listeners.add(fn); fn(list()); return function () { listeners.delete(fn); }; } };
  ready().catch(function () {});
})(window);
